import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-proprietario-licenciamento',
  templateUrl: './consulta-proprietario-licenciamento.component.html',
  styleUrls: ['./consulta-proprietario-licenciamento.component.scss']
})
export class ConsultaProprietarioLicenciamentoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
  }

}
